export const getDefaultDrivingConfiguration = () => {
  return {
    DesgasteRalenti: 1,
    DesgasteExcesoVelocidad: 2,
    DesgasteFrenadoIntenso: 4,
    DesgasteGiroBrusco: 2,
    DesgasteCurvaPeligrosa: 2,
    DesgasteAceleracionIntensa: 4,
    RiesgoRalenti: 0,
    RiesgoExcesoVelocidad: 3,
    RiesgoGiroBrusco: 4,
    RiesgoFrenadoIntenso: 0,
    RiesgoCurvaPeligrosa: 5,
    RiesgoAceleracionIntensa: 2,
    LimiteCGU: 10
  };
};



// WEBPACK FOOTER //
// ./src/utilities/driving.js